module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_fv-title-4909fc0ce6ca3d9f0ada17da2d9c98d7.png";